export const ASSET_SET_MEMBERSHIP_BATCH_SIZE = 500;
export const ASSET_SET_MEMBERSHIP_BATCH_CONCURRENCY = 2;

export async function loadInBoundedBatches<TItem, TResult>(
    items: readonly TItem[],
    loader: (batch: TItem[]) => Promise<TResult[]>,
    batchSize: number = ASSET_SET_MEMBERSHIP_BATCH_SIZE,
    concurrency: number = ASSET_SET_MEMBERSHIP_BATCH_CONCURRENCY
): Promise<TResult[]> {
    if (items.length === 0) return [];
    if (!Number.isInteger(batchSize) || batchSize < 1) {
        throw new Error('Asset Set membership batch size must be a positive integer.');
    }
    if (!Number.isInteger(concurrency) || concurrency < 1) {
        throw new Error('Asset Set membership batch concurrency must be a positive integer.');
    }

    const batches: TItem[][] = [];
    for (let index = 0; index < items.length; index += batchSize) {
        batches.push(items.slice(index, index + batchSize));
    }

    const results: TResult[][] = new Array(batches.length);
    let nextBatchIndex = 0;

    const worker = async () => {
        while (nextBatchIndex < batches.length) {
            const batchIndex = nextBatchIndex++;
            results[batchIndex] = await loader(batches[batchIndex]);
        }
    };

    const workerCount = Math.min(concurrency, batches.length);
    await Promise.all(Array.from({ length: workerCount }, () => worker()));
    return results.flat();
}
